import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-74ad6210"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

import { reactive, ref, computed, PropType, nextTick, onMounted } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue'
import SearchFilterBar from '@/components/searchFilterBar/index.vue'
import UsbTerminal from '@/views/dashboard/data-safe/usb-manage/usb-statistics/_components/terminal-view/_components/usb-terminal.vue'
import TerminalViewService, {
  QueryParams,
  TerminalItem,
} from '@/views/dashboard/data-safe/usb-manage/usb-statistics/_components/terminal-view/terminal-view.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { FormType, ObjectFormItem } from '@/components/cmForm/types'
import { TableOpt, TableActOpt } from '@/components/cmTable/types'
import { listCol } from '@/utils/list-columns-i18n'

type FilterKeys = Extract<
  keyof QueryParams,
  'peripheral_status' | 'device_status' | 'time_range'
>


export default /*#__PURE__*/_defineComponent({
  __name: 'usb-terminal-access-drawer-list',
  props: {
  hasPermission: {
    type: Boolean,
    default: true,
  },
  /** 与排行图时间筛选一致：1 全部 2 近24h 3 近7天 4 近一个月 */
  initialTimeRange: {
    type: Number as PropType<number>,
    required: true,
  },
  /** 从排行行带入，对应接口 search_word（计算机名优先） */
  initialSearchWord: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

const { t, locale } = useI18n()

const injector = useReflectiveInjector([TerminalViewService])
const terminalViewService = injector.get(TerminalViewService)
const dataApi = terminalViewService.getTerminalList.bind(terminalViewService)

const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)

const usbTerminalDrawerVisible = ref(false)
const currentTerminal = ref<TerminalItem | null>(null)

const queryParams = reactive<Partial<QueryParams>>({
  page: 1,
  limit: 20,
  sort_key: 'access_count',
  asc: false,
  search_word: props.initialSearchWord || '',
  peripheral_status: 3,
  device_status: 3,
  time_range: props.initialTimeRange,
})

const filterFormColumns = computed<ObjectFormItem<QueryParams, FilterKeys>>(() => {
  void locale.value
  return {
    peripheral_status: {
      colOpt: { style: 'flex: 0 0 120px' },
      label: t('usbPolicy.deviceStatus'),
      type: FormType.Select,
      outSearchFiledFlag: true,
      dictData: [
        { label: t('usbPolicy.all'), value: 3 },
        { label: t('usbPolicy.enabled'), value: 1 },
        { label: t('usbPolicy.disabled'), value: 2 },
      ],
      events: {
        change: () => {
          void refreshList()
        },
      },
    },
    device_status: {
      colOpt: { style: 'flex: 0 0 120px' },
      label: t('usbPolicy.terminalStatus'),
      type: FormType.Select,
      outSearchFiledFlag: true,
      dictData: [
        { label: t('usbPolicy.all'), value: 3 },
        { label: t('responseHandle.terminalLoginOnline'), value: 1 },
        { label: t('responseHandle.terminalLoginOffline'), value: 2 },
        { label: t('usbPolicy.terminalStatusExited'), value: 4 },
      ],
      events: {
        change: () => {
          void refreshList()
        },
      },
    },
    time_range: {
      colOpt: { style: 'flex: 0 0 130px' },
      label: t('usbPolicy.recordTime'),
      type: FormType.Select,
      outSearchFiledFlag: true,
      dictData: [
        { label: t('usbPolicy.all'), value: 1 },
        { label: t('usbPolicy.last24h'), value: 2 },
        { label: t('usbPolicy.last7d'), value: 3 },
        { label: t('usbPolicy.lastMonth'), value: 4 },
      ],
      events: {
        change: () => {
          void refreshList()
        },
      },
    },
  } as unknown as ObjectFormItem<QueryParams, FilterKeys>
})

const tableActOpt = computed<TableActOpt>(() => ({
  columnOpt: { label: listCol(t, 'operation'), width: 80, align: 'left', fixed: 'right' },
  actionButtons: () => [],
}))

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    height: '100%',
    path: 'list',
    showActionBar: false,
    showForm: false,
    showRightToolbar: false,
    rowKey: 'device_id',
    selection: false,
    bodyStyle: 'padding: 10px 16px',
    showTip: false,
    usePagination: false,
    scrollLoadThreshold: 10,
    scrollLoadDelay: 100,
    columns: [
      {
        label: listCol(t, 'computerName'),
        prop: 'computer_name',
        type: 'COMPUTER',
        columnOpt: { minWidth: 180, sortable: true },
      },
      {
        label: listCol(t, 'groupName'),
        prop: 'group_name',
        columnOpt: { minWidth: 120, sortable: true },
      },
      {
        label: listCol(t, 'userMark'),
        prop: 'user_mark',
        columnOpt: { minWidth: 120, sortable: true },
      },
      {
        label: listCol(t, 'ipAddress'),
        prop: 'client_ip',
        type: 'IP',
        columnOpt: { minWidth: 160, sortable: false },
      },
      {
        label: listCol(t, 'macAddress'),
        prop: 'mac',
        columnOpt: { minWidth: 140, sortable: false },
      },
      {
        label: listCol(t, 'status'),
        prop: 'device_status',
        columnOpt: { width: 100, sortable: true },
      },
      {
        label: listCol(t, 'triggerPolicy'),
        prop: 'strategy_name',
        columnOpt: { minWidth: 120, sortable: false, showOverflow: true },
      },
      {
        label: t('usbPolicy.columnTotalUsbAccessCount'),
        prop: 'access_count',
        columnOpt: { width: 160, sortable: true, align: 'left' },
      },
    ],
  }
})

function formatDeviceStatus(v?: number): string {
  if (v === 1) return t('responseHandle.terminalLoginOnline')
  if (v === 2) return t('responseHandle.terminalLoginOffline')
  if (v === 4) return t('usbPolicy.terminalStatusExited')
  return '--'
}

async function handleSearch(value: string) {
  await nextTick()
  queryParams.search_word = value
  void refreshList()
}

async function handleQuery(form: Partial<QueryParams>) {
  Object.assign(queryParams, form)
  void refreshList()
}

function handleReset() {
  queryParams.search_word = ''
  queryParams.peripheral_status = 3
  queryParams.device_status = 3
  queryParams.time_range = props.initialTimeRange
  void refreshList()
}

function handleAction() {}

function openUsbTerminalDrawer(row: TerminalItem) {
  currentTerminal.value = { ...row }
  usbTerminalDrawerVisible.value = true
}

function onUsbTerminalDrawerClosed() {
  currentTerminal.value = null
}

onMounted(() => {
  if (!props.hasPermission) return
  void refreshList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CmTable, {
      ref_key: "tableRef",
      ref: tableRef,
      class: "usb-terminal-access-drawer-table",
      tableOpt: tableOpt.value,
      tableActOpt: tableActOpt.value,
      "has-permission": props.hasPermission,
      api: _unref(dataApi),
      modelValue: queryParams,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryParams) = $event)),
      firstLoading: false,
      pageOption: {
      pageNumName: 'page',
      pageSizeName: 'limit',
    },
      onHandleAction: handleAction
    }, {
      header: _withCtx(() => [
        _createVNode(SearchFilterBar, {
          modelValue: queryParams,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams) = $event)),
          "form-columns": filterFormColumns.value,
          "show-search": true,
          "search-placeholder": _ctx.$t('common.phComputerIpUser'),
          "popover-threshold": 3,
          onSearch: handleSearch,
          onQuery: handleQuery,
          onReset: handleReset
        }, null, 8, ["modelValue", "form-columns", "search-placeholder"])
      ]),
      device_status: _withCtx(({ value }: { value?: number }) => [
        _createElementVNode("span", null, _toDisplayString(formatDeviceStatus(value)), 1)
      ]),
      access_count: _withCtx(({ row }: { row?: TerminalItem }) => [
        (row && Number(row.access_count) > 0)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "text",
              size: "small",
              onClick: ($event: any) => (openUsbTerminalDrawer(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.access_count), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(row?.access_count ?? '--'), 1))
      ]),
      _: 1
    }, 8, ["tableOpt", "tableActOpt", "has-permission", "api", "modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: usbTerminalDrawerVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((usbTerminalDrawerVisible).value = $event)),
      title: _ctx.$t('usbPolicy.usbStorageDeviceListTitle'),
      size: "70%",
      "destroy-on-close": "",
      direction: "rtl",
      onClosed: onUsbTerminalDrawerClosed
    }, {
      default: _withCtx(() => [
        (usbTerminalDrawerVisible.value && currentTerminal.value?.device_id)
          ? (_openBlock(), _createBlock(UsbTerminal, {
              key: 0,
              "current-terminal": currentTerminal.value,
              "peripheral-status": Number(queryParams.peripheral_status) || 3,
              "time-range": Number(queryParams.time_range) || 1
            }, null, 8, ["current-terminal", "peripheral-status", "time-range"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})